import { render, staticRenderFns } from "./ModalFilterReport.vue?vue&type=template&id=2ba22044&"
import script from "./ModalFilterReport.vue?vue&type=script&lang=js&"
export * from "./ModalFilterReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports